export const INTAKE_STEPS =
{
    POLICY:0, 
    INSUREE:1,
    CASE:2,
    LOCATION:5,
    TRAVEL:6,
    PARTY:7,
    HELP_PLAN:8,
    SUMMARY: 15
}